import { DEFAULT_STAGES, etapaLabel, etapasVisiblesPipeline } from "./pipelineUtils";
import { ETAPAS_EXPANSION, labelEtapaExpansion, oportunidadEstaAbierta } from "./expansion/expansionConstants";
import { buildStageMetrics } from "./reports/crmReportMetrics";

function leadCatalog(config = {}) {
  return etapasVisiblesPipeline(config).map(stage => ({ ...stage, nombre: etapaLabel(config, stage.id) }));
}

// Keep the two stage systems separate: a prospect and its explicit opportunities
// must not be counted twice, nor have conversions calculated across both systems.
export function opportunityStageChart(store, from, to) {
  const opportunities = store.oportunidadesExpansion || [];
  const explicit = new Set(opportunities.map(o => o.leadId));
  const leadHistory = (store.historialEtapas || []).filter(h => !explicit.has(h.leadId));
  const prospectStages = buildStageMetrics(leadHistory, from, to, store.config || { etapasPipeline: DEFAULT_STAGES }).map(stage => ({ ...stage, nombre: etapaLabel(store.config, stage.id) }));
  const opportunityStages = buildStageMetrics(opportunities.flatMap(o => (o.historialEtapas || []).map(h => ({ ...h, leadId: o.id }))), from, to,
    { etapasCatalogo: ETAPAS_EXPANSION.map(id => ({ id, nombre: labelEtapaExpansion(id) })) });
  const hasProspects = prospectStages.some(s => s.entradas > 0);
  const hasOpportunities = opportunityStages.some(s => s.entradas > 0);
  return [
    ...(hasProspects ? prospectStages.map(s => ({ ...s, id: "lead:" + s.id, colorId: s.id, nombre: hasOpportunities ? s.nombre + " · Leads" : s.nombre })) : []),
    ...(hasOpportunities ? opportunityStages.map(s => ({ ...s, id: "opp:" + s.id, colorId: s.id, nombre: hasProspects ? s.nombre + " · Negocios" : s.nombre })) : []),
  ];
}

export function pipelineStageChart(pipeline, allOpportunities, config) {
  const explicit = new Set((allOpportunities || []).map(o => o.leadId));
  const visibleStages = leadCatalog(config);
  const visibleIds = new Set(visibleStages.map(stage => stage.id));
  const groups = new Map();
  for (const l of (pipeline.leads || []).filter(l => !explicit.has(l.id) && visibleIds.has(l.etapa) && !["inscrito", "perdido"].includes(l.etapa))) {
    const key = "lead:" + l.etapa;
    const row = groups.get(key) || { id: key, nombre: etapaLabel(config, l.etapa), colorId: l.etapa, entradas: 0 };
    row.entradas++; groups.set(key, row);
  }
  for (const o of (pipeline.oportunidadesExpansion || []).filter(oportunidadEstaAbierta)) {
    const key = "opp:" + o.etapa;
    const row = groups.get(key) || { id: key, nombre: labelEtapaExpansion(o.etapa), colorId: o.etapa, entradas: 0 };
    row.entradas++; groups.set(key, row);
  }
  const order = [...visibleStages.map(s => "lead:" + s.id), ...ETAPAS_EXPANSION.map(id => "opp:" + id)];
  const rank = new Map(order.map((id, i) => [id, i]));
  return [...groups.values()].sort((a, b) => (rank.get(a.id) ?? Infinity) - (rank.get(b.id) ?? Infinity) || a.id.localeCompare(b.id)).map(r => ({ ...r, conversion: null }));
}
